export default {
  "container": "_container_119kl0",
  "back-button": "_back-button_119kl0",
  "content": "_content_119kl0",
  "total-operations": "_total-operations_119kl0"
};
